// 页面样式
import css from 'css/page/game.scss'

// 常量
import * as constants from 'js/constants/index'
// 公共方法
import {
  comment,
  dataBus,
  memberShip,
  message,
  blkNavTag,
  qrcode,
  showMore,
} from 'js/common/index'
// 动画
import {
  swiper,
  viewer,
} from 'js/animation/index'
// 工具方法
import * as utils from 'js/utils/index'

/**
 * 文章列表初始化
 */
function articleListInit() {
  let obj = document.querySelector('.article')
  if (!obj) {
    utils.log.e(`[articleListInit] DOM element whose selector's .article not found.`)
    return
  }

  let tagList = obj.querySelector('.tag-container')
  if (tagList && tagList.children.length === 0) {
    $(obj).remove()
  }

  blkNavTag.init({
    aTag: obj.querySelector('.top-rt a'),
    tagList,
    blkList: obj.querySelector('.list-containers'),
  })
}

/**
 * 绑定 DOM 事件
 */
function bindEvts() {
  console.log('game.js bindevt') //lj

  console.log("初始化下载按钮")
  // 下载按钮的事件绑定 lj
  downGameBtnInit();

  articleListInit()
  
  memberFormInit()
  
  swipersInit()
  
  commentEvtsInit()   
  
  console.log('bindEvts 完成') //lj
}


/**
 * 游戏下载按钮 初始化  lj
 */
function  downGameBtnInit() {
    $('.yui-qrbtn0').click(function() {
      console.log("点击下载游戏")

      let user = dataBus.get('user')
      if (!user) {
        return message.common.pleaseLogin({
          callback: () => {
            let obj = document.querySelector('header a.login')
            if (obj) {
              obj.click()
            }
          },
          mode: 1,
        })
      }else {
        if(user.idcard == '') {
          console.log("登录成功，没有实名认证过。所以显示实名")
            // 实名认证  
          memberShip.showRealName({
            form: '.yui-memberform0-login'
              })
          }else {
            // 执行下载
            console.log("已经实名认证了")
            // "${Prefix}${AppInstall.DownloadLink}&source=pc_game_index"
            var data = $('.yui-qrbtn0').attr('data-href');
            console.log("下载地址")
            console.log(data)
            window.location.href = data;
          }
          
        }
    })
}

/**
 * 评论事件初始化
 */
function commentEvtsInit() {
  let maskObj = document.querySelector('.mask-cmmt')

  if (!maskObj) {
    utils.log.e(`[commentEvtsInit] DOM element whose selector's .mask-cmmt not found.`)
    return
  }
  
  let gameId = "";
  // 判断元素不为NULL
  if(document.querySelector('.sec-cmmt') != null) {
    gameId = document.querySelector('.sec-cmmt').getAttribute(constants.api.gameIdPropertyName)
  }

  comment.publishInit({
    badBtn: maskObj.querySelector('.yui-icon-cry0-yellow').parentNode,
    cancelBtn: '.yui-ccmmt-publish0 .btn-op.cancel',
    cancelSuccess: hideMask,
    data: {
      gameId,
    },
    goodBtn: maskObj.querySelector('.yui-icon-smile0-yellow').parentNode,
    ipt: '.yui-ccmmt-publish0 textarea',
    submitBtn: '.yui-ccmmt-publish0 .btn-op.push',
    submitSuccessBefore: () => window.location.href = window.location.href,
    submitFinally: hideMask,
  })

  comment.thumbInit({
    list: '.cmmt-blk',
    btnSelector: '.btn-thumb',
  })

  for (let o of document.querySelectorAll('.sec-cmmt .yui-thumbbtn0')) {
    o.addEventListener('click', showMask, false)
  }

  function showMask() {
    if (!maskObj) {
      utils.log.e(`[commentEvtsInit][showMask] DOM element whose selector's .mask-cmmt not found.`)
      return
    }

    let user = dataBus.get('user')
    if (!user) {
      return message.common.pleaseLogin({
        callback: () => {
          let obj = document.querySelector('header a.login')
          if (obj) {
            obj.click()
          }
        },
        mode: 1,
      })
    }

    let obj = this.querySelector('.yui-icon-smile0-yellow')
    if (obj) {
      // 点击笑脸按钮
      $('.mask-cmmt .yui-icon-cry0-yellow').toggleClass('yui-icon-cry0-yellow yui-icon-cry0-gray')
    }

    obj = this.querySelector('.yui-icon-cry0-yellow')
    if (obj) {
      // 点击哭脸按钮
      $('.mask-cmmt .yui-icon-smile0-yellow').toggleClass('yui-icon-smile0-yellow yui-icon-smile0-gray')
    }

    maskObj.style.display = 'block'
  }

  function hideMask() {
    if (!maskObj) {
      utils.log.e(`[commentEvtsInit][hideMask] DOM element whose selector's .mask-cmmt not found.`)
      return
    }

    // 重置评论心情图标
    let obj = maskObj.querySelector('.yui-icon-smile0-yellow, .yui-icon-smile0-gray')
    if (obj) {
      $(obj).addClass('yui-icon-smile0-yellow').removeClass('yui-icon-smile0-gray')
    }

    obj = maskObj.querySelector('.yui-icon-cry0-yellow, .yui-icon-cry0-gray')
    if (obj) {
      $(obj).addClass('yui-icon-cry0-yellow').removeClass('yui-icon-cry0-gray')
    }

    maskObj.querySelector('textarea').value = ''
    maskObj.style.display = 'none'
  }
}

/**
 * 评论 UI 初始化
 */
function cmmtUIInit() {
  let maskObj = document.querySelector('.mask-cmmt')
  if(maskObj == null) {
    return;
  }

  comment.loadCmmtList({
    mode: 0,
    params: {
      desc: '.desc-load',
      id: '.sec-cmmt',
      pageList: '.yui-pagination0 .pagelist',
      target: '.sec-cmmt .cmmt-blk',
    },
  })
  comment.loadGood({
    bad: '.txt-add.bad',
    data: {
      gameId: document.querySelector('.sec-cmmt').getAttribute(constants.api.gameIdPropertyName)
    },
    good: '.txt-add.good',
  })
  comment.loadUserData({
    avatar: '.yui-ccmmt-top0 .avatar img',
    mode: 1,
    mode1Callback: () => {
      let obj = document.querySelector('header a.login')
      if (obj) {
        obj.click()
      }
    },
    userName: '.yui-ccmmt-top0 .avatar .username',
  })
}

/**
 * 登录相关表单初始化
 */
function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => {
      // 登陆完毕刷新页面，初始化头部和评论点赞状态
      window.location.href = window.location.href
    },
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
  // 实名认证  
  memberShip.realNameFormInit({
    form: '.yui-memberform0-real-name',
    mask: '.mask-member',
  })
}

/**
 * 滑块初始化
 */
function swipersInit() {
  // 宣传画报滑块
  swiper.init({
    selector: '.swiper0',
    options: {
      autoplay: false,
      slidesPerView: 'auto',
      navigation: {
        prevEl: '.swiper0 .prev-el',
        nextEl: '.swiper0 .next-el',
      }
    }
  })
}

/**
 * 游戏截图初始化
 */
function screenshotInit() {
  swiper.imgResize({
    imgs: '.swiper0 .swiper-slide img',
    ht: {
      horiz: {
        value: 300,
        unit: 'px',
      },
      verti: {
        value: 390,
        unit: 'px',
      }
    },
  }).then(() => {
    swipersInit()

    if (!viewer.init({
        wrapper: '.swiper0 .swiper-wrapper',
      })) {
      return
    }

    viewer.getImgUrl({
      imgs: '.swiper-slide img',
    })
  }).catch(e => {
    if (e && e.message) {
      utils.log.e(e.message)
    }
  })
}

/**
 * 二维码初始化
 */
function QRCodeInit() {
  let parser = new utils.UrlParser()

  qrcode.init({
    ht: 140,
    prefix: parser.domainName,
    target: '.yui-qrbtn0 .qrcode',
    wt: 140,
  })
}

/**
 * 游戏介绍显示更多
 */
function showMoreIntro() {
  showMore({
    container: '.introduce .content > div',
    dpBtn: '.btn-dp',
    hBtn: '.btn-hide',
    jsJump: true,
    limitValue: 3,
    mode: 'line',
  })
}

/**
 * UI 初始化
 */
function uiInit() {

  showMoreIntro()
  
  // QRCodeInit()
  
  screenshotInit()

  cmmtUIInit()
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  console.log("dom 完毕 详情页收到广播 ")
  uiInit()
  bindEvts()  
})



// WEBPACK FOOTER //
// ./js/page/game.js